var _path, _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.33334C7.6318 1.33334 7.33333 1.63181 7.33333 2V7.33334H1.99999C1.63181 7.33334 1.33333 7.63181 1.33333 8C1.33333 8.36819 1.63181 8.66667 2 8.66667H7.33333V14C7.33333 14.3682 7.6318 14.6667 8 14.6667C8.36819 14.6667 8.66666 14.3682 8.66666 14V8.66667H14C14.3682 8.66667 14.6667 8.36819 14.6667 8C14.6667 7.63181 14.3682 7.33334 14 7.33334H8.66666V2C8.66666 1.63181 8.36819 1.33334 8 1.33334Z",
    fill: "#D8D8D8"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask3",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.33334C7.6318 1.33334 7.33333 1.63181 7.33333 2V7.33334H1.99999C1.63181 7.33334 1.33333 7.63181 1.33333 8C1.33333 8.36819 1.63181 8.66667 2 8.66667H7.33333V14C7.33333 14.3682 7.6318 14.6667 8 14.6667C8.36819 14.6667 8.66666 14.3682 8.66666 14V8.66667H14C14.3682 8.66667 14.6667 8.36819 14.6667 8C14.6667 7.63181 14.3682 7.33334 14 7.33334H8.66666V2C8.66666 1.63181 8.36819 1.33334 8 1.33334Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.da10749ca6113ccc0fee01cc42f15d9e.svg";
export { ForwardRef as ReactComponent };